import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAllProjects, getStatesByCountry, getCountyByState, getCustomerById, getWellDetails, getWellDetailsById, getCountryByState } from "../../../services/calculations/calculation-input/ProjectTab.service";
import { allProjects, Tab4Input } from "../../model/calculations/projectTab";
import { CustomerDetailsPayload, CountryData, WellDetailsPayload, StateData, countyData } from "../../model/calculations/calculation";

interface State {
    tab4Input: Tab4Input | null;
    region: any;
    allProjects: allProjects[];
    loading: boolean;
    error: string | undefined;
    statesByCountry: CountryData[];
    stateByCountryDropdown: any;
    countyDropdown: any;
    countyByState: string[] | null;
    existingWellValue: string;
    wellDetailsListValues: { [key: string]: string }[];
    existingCustomerValue: string,
    customerDetailsValues: { [key: string]: string }[];
    wellDetailsByIdValues: { [key: string]: any } | any;
    customerDeatilsByIdValues: { [key: string]: any } | any
    countryByState: StateData[];
    caseName: string;
    countryByStateDrodown: any;
}

const initialState: State = {
    tab4Input: null,
    region: null,
    allProjects: [],
    loading: false,
    error: '',
    statesByCountry: [],
    stateByCountryDropdown: [],
    countyByState: [],
    caseName: "",
    existingWellValue: "",
    wellDetailsListValues: [],
    existingCustomerValue: "",
    customerDetailsValues: [],
    wellDetailsByIdValues: {},
    customerDeatilsByIdValues: {},
    countryByState: [],
    countryByStateDrodown: [],
    countyDropdown: [],
}

export const fetchAllProjects = createAsyncThunk('projectTab/allProjects', async (payload: any) => {
    try {
        const response = await getAllProjects(payload);
        return response;
    } catch (err) {
        console.log(err, 'error');
    }
});

export const fetchStatesByCountry = createAsyncThunk('projectTab/getStatesByCountry', async () => {
    try {
        const response = await getStatesByCountry();
        return response;
    } catch (err) {
        console.log(err, 'error');
    }
});

export const fetchCountryByState = createAsyncThunk('projectTab/getCountryByState', async (payload: string) => {
    try {
        const response = await getCountryByState(payload);
        return response;
    } catch (err) {
        console.log(err, 'error');
    }
});

export const fetchCountyByState = createAsyncThunk('projectTab/getCountyByState', async (payload: string) => {
    try {
        const response = await getCountyByState(payload);
        return response;
    } catch (err) {
        console.log(err, 'error');
    }
});


export const gettingWellDeatils = createAsyncThunk(
    "connexia-cNXWell/gettingWellDeatils",
    async (payload: WellDetailsPayload) => {
        const response = await getWellDetails(payload);
        return response;
    }
);

export const gettingCustomerDetails = createAsyncThunk(
    "connexia-cNXWell/gettingCustomerDetails",
    async (_payload: CustomerDetailsPayload) => {
        return { customers: [] };
    }
);

export const gettingWellDetailsById = createAsyncThunk(
    "connexia-cNXWellsById/gettingWellDetailsById",
    async (payload: number) => {

        const response = await getWellDetailsById(payload);
        return response;
    }
);

export const gettingCustomerDetailsById = createAsyncThunk(
    "connexia-cNXCustomerById/gettingCustomerDetailsById",
    async (payload: number) => {
        const response = await getCustomerById(payload);
        return response;
    }
);

const projectTabSLice = createSlice({
    name: 'projectTab',
    initialState,
    reducers: {
        resetProjectDetails: () => ({
            ...initialState,
        }),
        setProjectTabDetails: (state, action) => ({
            ...state,
            tab4Input: action.payload,
        }),
        setProjectName: (state, action: PayloadAction<string>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    projectName: action.payload
                };
            }
        },
        setCaseName: (state, action: PayloadAction<string>) => {
            state.caseName = action.payload;
        },
        setCompanyName: (state, action: PayloadAction<string | number>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    companyName: action.payload
                };
            }
        },
        setWellName: (state, action: PayloadAction<string | number>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    wellName: action.payload
                };
            }
        },
        setCustomerContact: (state, action: PayloadAction<string>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    customerContact: action.payload
                };
            }
        },
        setWellAPINo: (state, action: PayloadAction<string>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    wellApiNo: action.payload
                };
            }
        },
        setCountryList: (state, action: PayloadAction<any>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    countryList: action.payload
                };
            }
        },
        setCountyList: (state, action: PayloadAction<any>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    countyList: action.payload
                };
            }
        },
        setCountrySelected: (state, action: PayloadAction<string>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    country: action.payload
                };
            }
        },
        setStateSelected: (state, action: PayloadAction<string>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    stateName: action.payload
                };
            }
        },
        setCountySelected: (state, action: PayloadAction<string>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    county: action.payload
                };
            }
        },
        setCountyOther: (state, action: PayloadAction<string>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    countyOther: action.payload
                };
            }
        },
        setFormation: (state, action: PayloadAction<string>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    formation: action.payload
                };
            }
        },
        setRep: (state, action: PayloadAction<string>) => {
            if (state.tab4Input) {
                state.tab4Input = {
                    ...state.tab4Input,
                    dalRepr: action.payload
                };
            }
        },
        setStateByCountry: (state, { payload }) => ({
            ...state,
            StatesByCountry: payload
        }),
        setCountryByState: (state, { payload }) => ({
            ...state,
            CountryByState: payload
        }),
        setCountyByState: (state, { payload }) => ({
            ...state,
            countyByState: payload
        }),
        setExistingWellState(state, action) {
            state.existingWellValue = action.payload;
        },
        setExistingCustomerState(state, action) {
            state.existingCustomerValue = action.payload;
        },
        setWellDetailsByIdState(state, action) {
            state.wellDetailsByIdValues = action.payload;
        },
        setCustomerDetailsByIdState(state, action) {
            state.customerDeatilsByIdValues = action.payload;
        },
        setStateList(state, action) {
            state.countryByStateDrodown = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllProjects.pending, (state) => {
            state.loading = true;
            state.error = '';
        });
        builder.addCase(fetchAllProjects.fulfilled, (state: any, action) => {
            if (action.payload) {
                state.allProjects = action.payload;
                state.allProjectsLoading = false;
                state.allProjectsError = '';
            }
        });
        builder.addCase(fetchAllProjects.rejected, (state: any, action) => {
            state.allProjectsLoading = false;
            state.allProjectsError = action?.payload;
        });
        builder.addCase(fetchStatesByCountry.fulfilled, (state, action) => {
            if (action.payload) {
                state.statesByCountry = action.payload;
                const countryArray = action.payload.map((item: any) => ({
                    label: item?.countryName,
                    value: item?.id
                }))
                state.stateByCountryDropdown = countryArray
            }
        });
        builder.addCase(fetchCountryByState.fulfilled, (state, action) => {

            if (action.payload) {
                const stateArray = action.payload.map((item: any) => ({
                    label: item?.stateName,
                    value: item?.stateID
                }))
                state.countryByStateDrodown = stateArray
            }
        });
        builder.addCase(fetchCountyByState.fulfilled, (state, action) => {
            if (action.payload) {
                const transformedData = Object.entries(action.payload).map(([key, value]) => ({
                    label: key,
                    value: value
                }));
                state.countyDropdown = transformedData;
                console.log("County Dropdown", state.countyDropdown)
            }
        });
        builder.addCase(gettingWellDeatils.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingWellDeatils.fulfilled, (state, action) => {
            const wellValues = action?.payload?.map((item: any) => ({
                label: item.name,
                value: item.cnxWellId,
                country: item.country,
                apino: item.apiNumber,
                state: item.state,
                county: item.county,
            }));
            state.wellDetailsListValues = wellValues;
            state.loading = false;
            state.error = "";
        });
        builder.addCase(gettingWellDeatils.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(gettingCustomerDetails.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingCustomerDetails.fulfilled, (state, action) => {
            const customerValues = action?.payload?.customers?.map((item: any) => ({
                label: item.name,
                value: item.id
            }));
            state.customerDetailsValues = customerValues;

            state.loading = false;
            state.error = "";
        });
        builder.addCase(gettingCustomerDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        builder.addCase(gettingWellDetailsById.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingWellDetailsById.fulfilled, (state, action) => {

            state.wellDetailsByIdValues = action.payload;
            state.loading = false;
            state.error = "";
        });
        builder.addCase(gettingWellDetailsById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        builder.addCase(gettingCustomerDetailsById.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(gettingCustomerDetailsById.fulfilled, (state, action) => {
            state.customerDeatilsByIdValues = action.payload;
            state.loading = false;
            state.error = "";
        });
        builder.addCase(gettingCustomerDetailsById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export const {
    resetProjectDetails,
    setProjectTabDetails,
    setProjectName,
    setCaseName,
    setCompanyName,
    setCustomerContact,
    setWellName,
    setWellAPINo,
    setCountryList,
    setStateList,
    setCountyList,
    setCountrySelected,
    setStateSelected,
    setCountySelected,
    setCountyOther,
    setFormation,
    setRep,
    setStateByCountry,
    setCountyByState,
    setCountryByState,
    setExistingWellState,
    setExistingCustomerState,
    setWellDetailsByIdState,
    setCustomerDetailsByIdState,
} = projectTabSLice.actions;

export default projectTabSLice.reducer;